module.exports = __webpack_public_path__ + "img/brave.dcb02736.png";